/*
 *
 * MerchantPayByLinkDetail
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 20-Nov-2024
*/

import MerchantPayByLinkDetail from './MerchantPayByLinkDetailContainer'

export default MerchantPayByLinkDetail
